import { SVGProps } from 'react';

const SignalHigh = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 20h.01M7 20v-4m5 4v-8m5 8V8"
    />
  </svg>
);
export default SignalHigh;
